<!--
 * @Author: ShiWeiShan
 * @Date: 2020-06-23 14:54:57
 * @LastEditTime: 2020-11-18 15:16:01
 * @LastEditors: ShiWeiShan
 * @Description: 选择用水性质
 * @FilePath: \FS-JS-PCWEB\src\components\util\selectAddr.vue
-->
<template>
  <el-cascader
    size="mini"
    v-model="localValue"
    :options="options"
    :props="{label: 'name', value: 'oid', children: 'child', emitPath: false}"
    @change="handleChange"
    :disabled="disabled"
    :show-all-levels="true"
  >
    <template slot-scope="{ node, data }">
      <i class="iconfont" :class="getClass(data)"></i>
      <span class="node-text">{{ data.name }}</span>
    </template>
  </el-cascader>
</template>

<script>
import {
  A_AAL_TreeQuery
} from '@/assets/js/axiosPresets.js'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Number,
    disabled: Boolean
  },
  data () {
    return {
      localValue: null,
      options: []
    }
  },
  watch: {
    value () {
      this.localValue = this.value || null
    }
  },
  methods: {
    async getTreeData () {
      const res = await A_AAL_TreeQuery({
        pid: 1,
        scale: 2
      })
      this.options = [
        {
          oid: 1,
          child: this.beautyTreeData(res.data.Content, 1),
          level: 0,
          name: '佛山市'
        }
      ]
    },
    getClass (data) {
      let myClass = ''
      switch (data.level) {
        case 0:
          myClass = 'js-icon-level-1'
          break
        case 1:
          myClass = 'js-icon-level-2'
          break
        case 2:
          myClass = 'js-icon-level-3'
          break
        default:
          break
      }
      return myClass
    },
    beautyTreeData (data, level) {
      data.forEach(item => {
        if (level < 2) {
          item.level = level
          item.child = item.child || []
          this.beautyTreeData(item.child || [], level + 1)
        } else if (level === 2) {
          item.child = null
        }
      })
      return data
    },
    handleChange (e) {
      this.$emit('change', this.localValue)
      console.log(e)
    }
  },
  mounted () {
    this.localValue = this.value
    this.getTreeData()
  }
}
</script>

<style>
</style>
